import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/site/Login';
import BaseList from '@/views/base/list';
import BaseEdit from '@/views/base/edit';
import BaseDetail from '@/views/base/detail';
import Home from '../views/Home.vue'
import TypeList from '@/views/type/list';
import changePass from "@/views/site/changePass";
import DashBoard from "@/views/site/DashBoard";

//system
import SystemBase from '@/views/system/base';
import SystemPay from '@/views/system/pay';
import SystemDingyue from '@/views/system/dingyue';
import SystemFuwu from '@/views/system/fuwu';
import SystemMini from '@/views/system/mini';
import SystemService from '@/views/system/service';
import SystemAbout from '@/views/system/about';
import SystemWeixinbidsdes from '@/views/system/weixinbidsdes';
import System404 from '@/views/system/404';
import SystemSecret from '@/views/system/secret';
import HotBids from '@/views/hot/bids';
import HotCompany from '@/views/hot/company';
import HotToubiao from '@/views/hot/toubiao';


const routerPush = VueRouter.prototype.push;

VueRouter.prototype.push = function(location){
  return routerPush.call(this, location).catch(error=> error)
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    redirect: "/dashboard",
    component: Home,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: DashBoard
      },
      {
        path: '/changePass',
        name: 'changePass',
        component: changePass
      },
      {
        path: '/system/base',
        name: 'SystemBase',
        component: SystemBase
      },
      {
        path: '/system/about',
        name: 'SystemAbout',
        component: SystemAbout
      },
      {
        path: '/system/fuwu',
        name: 'SystemFuwu',
        component: SystemFuwu
      },
      {
        path: '/system/dingyue',
        name: 'SystemDingyue',
        component: SystemDingyue
      },
      {
        path: '/system/mini',
        name: 'SystemMini',
        component: SystemMini
      },
      {
        path: '/system/pay',
        name: 'SystemPay',
        component: SystemPay
      },
      {
        path: '/system/service',
        name: 'SystemService',
        component: SystemService
      },
      {
        path: '/system/secret',
        name: 'SystemSecret',
        component: SystemSecret
      },
      {
        path: '/system/weixinbidsdes',
        name: 'SystemWeixinbidsdes',
        component: SystemWeixinbidsdes
      },
      {
        path: '/system/404',
        name: 'System404',
        component: System404
      },
      {
        path: '/hot/bids',
        name: 'HotBids',
        component: HotBids
      },
      {
        path: '/hot/company',
        name: 'HotCompany',
        component: HotCompany
      },
      {
        path: '/hot/toubiao',
        name: 'HotToubiao',
        component: HotToubiao
      },
      // {
      //   path: "/type/:type",
      //   name: "TypeList",
      //   component: TypeList,
      //   meta:{title:'字典管理'}
      // },///rule/path/list
      // {
      //   path: "/rule/path/list",
      //   name: "TypeList",
      //   component: TypeList,
      //   meta:{title:'字典管理'}
      // },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]

//   const routes = [
//     {
//       path: "/",
//       name: "Home",
//       redirect: "/home"
//       // component: Home
//     },
//     {
//       path: "/home",
//       name: "home",
//       component: Home,
//       children: [
//         {
//           path: "/type/:type",
//           name: "TypeList",
//           component: TypeList,
//           meta:{title:'字典管理'}
//         },
//       ]
//     },
//     {
//       path: '/login',
//       name: 'login',
//       component: Login
//     },
// ];

let _paths = window.config.paths();

for(let i in _paths){

  let _listRouter = _paths[i].listRouter;
  let _editRouter = _paths[i].editRouter;

  let _listPath = {
    path:_listRouter,
    name:i+'List',
    component:_paths[i].list.com ? () => import('@/views' + _paths[i].list.com) : BaseList,
    meta:{title:_paths[i].name}
  }

  routes[0].children.push(_listPath);

  if(_paths[i].editRouter){
    let _editPath = null;
    _editPath = {
      path: _editRouter,
      name: i + 'Edit',
      component: _paths[i].edit.com ? () => import('@/views' + _paths[i].edit.com) : BaseEdit,
      meta: {title: '保存' + _paths[i].name}
    }
    routes[0].children.push(_editPath);
  }

  if(_paths[i].detailRouter){
    let _detailPath = {
      path:_paths[i].detailRouter,
      name:i+'Edit',
      component:_paths[i].detail && _paths[i].detail.com ? () => import('@/views' + _paths[i].detail.com) : BaseDetail,
      meta:{title:_paths[i].name+'详情'}
    }

    routes[0].children.push(_detailPath);
  }

  if(_paths[i].addRouter){
    let _addPath = {
      path:_paths[i].addRouter,
      name:i+'Add',
      component:_paths[i].add && _paths[i].add.com ? () => import('@/views' + _paths[i].add.com) : BaseEdit,
      meta:{title:'添加'+_paths[i].name}
    }

    routes[0].children.push(_addPath);
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
